import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';
import Const from 'constants';
import {addRoleSuffix, getSimplexUnitName} from 'helpers/simplex-helper';

export default class LpClassic extends BaseLP {
    preparePlayerByLPPlayerId({incomingValues: {id}}) {
        const state = Action.getState();
        const {preparedPlayers} = state.playersData;
        const playersGroupedById = preparedPlayers.groupedBy.playerId();

        const unit = id.replace(Const.LP_UNIT_PREFIX, '').split(Const.LP_ITEM_DELIMITER);

        const player = {...playersGroupedById[unit[0]]};

        if (Const.LP_CAPTAIN_PLAYER_POSITION === Number(unit[1])) {
            player.setAsCaptain();
        }

        player.position = Number(player.position[0]);

        return player;
    }

    prepareMaxSection({incomingValues = {}}) {
        return this.exec('objectiveMax', incomingValues);
    }

    exposureMax({incomingValues = {}}) {
        return this.exec('prepareSectionByExposureMax_ShowDown', incomingValues, {});
    }

    exposureMin({incomingValues = {}}) {
        return this.exec('prepareSectionByExposureMin_ShowDown', incomingValues);
    }

    prepareGeneralSection({incomingValues = {}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        const playersIndexedById = preparedPlayers.groupedBy.playerId();

        let result = [];
        Object.values(playersIndexedById).map((player) => {
            const prefix = getSimplexUnitName(player.getId());

            if (player.isDriver()) {
                result.push(addRoleSuffix({prefix, role: Const.CAPTAIN_MODE}));
            }

            result.push(addRoleSuffix({prefix, role: Const.DEFAULT_MODE}));
        });
        //console.log("gen\n",result);
        return result;
    }

    prepareBoundSection({incomingValues = {}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        const playersIndexedById = preparedPlayers.groupedBy.playerId();

        const result = {};
        Object.values(playersIndexedById).map((player) => {
            const prefix = getSimplexUnitName(player.getId());

            if (player.isDriver()) {
                const isExcludedByCapMode = player.isExcludedByMode(Const.CAPTAIN_MODE);
                result[addRoleSuffix({prefix, role: Const.CAPTAIN_MODE})] = {
                    atLeast: 0,
                    atMost: isExcludedByCapMode ? 0 : 1,
                };
            }

            const isExcludedByFlexMode = player.isExcludedByMode(Const.FLEX_MODE);
            result[addRoleSuffix({prefix, role: Const.DEFAULT_MODE})] = {
                atLeast: 0,
                atMost: isExcludedByFlexMode ? 0 : 1,
            };
        });
        //console.log("bound\n",result);
        return result;
    }

    prepareMaxRandomSection({incomingValues = {}}) {
        const {
            lineupsData: {rawLineups},
            playersData: {preparedPlayers},
            randomPoints,
        } = Action.getState();
        const players = preparedPlayers.groupedBy.playerId();
        const lineupNumber = 1 + rawLineups.getQuantity();

        const result = {};

        if (randomPoints.items.hasOwnProperty(lineupNumber)) {
            const pointsList = randomPoints.items[lineupNumber];
            Object.values(players).map((player) => {
                if (player.isDriver()) {
                    const key = addRoleSuffix({prefix: player.getId(), role: Const.CAPTAIN_MODE});
                    if (pointsList.hasOwnProperty(key)) {
                        result[getSimplexUnitName(key)] = pointsList[key] * 1;
                    }
                }

                const key = addRoleSuffix({prefix: player.getId()});
                if (pointsList.hasOwnProperty(key)) {
                    result[getSimplexUnitName(key)] = pointsList[key] * 1;
                }
            });
        }

        return {...result};
    }

    subjectToPermanent() {
        const constraints = {
            players: this.exec('player', {}, ''),
            salary: this.exec('salary', {}, ''),
            positions: this.exec('positions', {}, ''),
            teams: this.exec('team', {}, ''),
            captainPositions: this.exec('captainPositions', {}, ''),
            perTeamDriverLimits: this.exec('perTeamDriverLimits', {}, ''),
            captainToConstructorStacking: this.exec('captainToConstructorStacking', {}, ''),
        };
        // Object.keys(constraints).map(key => console.log(key, constraints[key]))
        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            uniquePositions: this.exec('uniquePositions', {}, ''),
            createdLineups: this.exec('createdLineups', {}, ''),
            exposureMax: this.exec('exposureMax', {}, ''),
            exposureMin: this.exec('exposureMin', {}, ''),
        };
        // Object.keys(constraints).map(key => console.log(key, constraints[key]))
        return {...constraints};
    }
}
